import { makeStyles } from "@mui/styles";
import { COLORS } from "../../../constant/colors";

export default makeStyles(() => ({
  bestSellerSec: {
    padding: "70px 0",
    background: COLORS.white,
    marginBottom: 0,
    "@media (max-width: 600px)": {
      padding: "30px 0",
    },
  },
  sectionHeader: {
    textAlign: "center",
    marginBottom: 30,
    "@media (max-width: 600px)": {
      marginBottom: 20,
    },
  },
  heading: {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: COLORS.textPrimary,
    marginBottom: 16,
    fontFamily: "'Poppins', sans-serif",
    position: "relative",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -8,
      left: "50%",
      transform: "translateX(-50%)",
      width: 60,
      height: 4,
      background: `linear-gradient(90deg, ${COLORS.primary} 0%, ${COLORS.secondary} 100%)`,
      borderRadius: 2,
    },
    "@media (max-width: 600px)": {
      fontSize: "1.8rem",
      marginBottom: 12,
    },
  },
  subheading: {
    fontSize: "1.1rem",
    color: COLORS.textSecondary,
    maxWidth: 600,
    margin: "0 auto !important",
    lineHeight: 1.6,
    fontFamily: "'Poppins', sans-serif",
    "@media (max-width: 600px)": {
      fontSize: "0.9rem",
    },
  },
  productSliderSec: {
    "& .react-multi-carousel-list": {
      padding: "0 20px",
    },
    "& .react-multi-carousel-item": {
      padding: "0 15px",
    },
    "& .react-multi-carousel-arrow": {
      background: `linear-gradient(135deg, ${COLORS.saffron} 0%, ${COLORS.saffronLight} 100%)`,
      border: "none",
      borderRadius: "50%",
      width: 50,
      height: 50,
      "&:hover": {
        background: `linear-gradient(135deg, ${COLORS.saffronLight} 0%, ${COLORS.saffron} 100%)`,
        transform: "scale(1.1)",
      },
      "&::before": {
        fontSize: "20px",
        color: COLORS.white,
      },
    },
    "& .react-multi-carousel-arrow--left": {
      left: 0,
    },
    "& .react-multi-carousel-arrow--right": {
      right: 0,
    },
  },
  boxRow: {
    "@media (max-width: 767px)": {
      padding: "0 15px",
    },
  },
  myCol: {
    padding: "15px !important",
    textAlign: "center",
    transition: "all 0.3s ease-in-out",
    "& h3": {
      transition: "all 0.3s ease-in-out",
    },
    "&:hover": {
      transform: "translateY(-10px)",
      "& h3": {
        color: COLORS.secondary,
      },
    },
    "@media (max-width: 767px)": {
      padding: "0px 8px 15px !important",
      "& h3": {
        fontSize: "14px !important",
        marginBottom: "2px !important",
        fontWeight: "400 !important",
      },
    },
    "@media (max-width: 467px)": {
      "& h3": {
        fontSize: "12px !important",
      },
    },
  },
  productImg: {
    width: "100%",
  },
  content: {
    textAlign: "center",
    marginTop: 20,
    "@media (max-width: 767px)": {
      marginTop: 10,
    },
  },
  rating: {
    marginTop: -4,
    "@media (max-width: 767px)": {
      marginTop: 0,
    }
  },
  ratingStar: {
    color: COLORS.secondary,
    "@media (max-width: 475px)": {
      fontSize: "14px !important",
    }
  },
  star: {
    color: COLORS.secondary,
    "@media (max-width: 767px)": {
      fontSize: "12px !important",
    },
  },
  priceSec: {
    '@media (max-width: 600px)': {
      marginTop: -5,
    }
  },
  del: {
    fontSize: 15,
    fontFamily: "Poppins",
    fontWeight: "500",
    color: COLORS.lightGrey1,
    "@media (max-width: 767px)": {
      fontSize: 13,
    },
  },
  price: {
    color: COLORS.primary,
    fontSize: 16,
    fontFamily: "Poppins",
    fontWeight: "500",
    "@media (max-width: 767px)": {
      fontSize: 14,
    },
  },
}));
